var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      value: _vm.chosenCompanies,
      options: _vm.companies,
      multiple: _vm.multiple,
      invalid: _vm.invalid,
      loading: _vm.$apollo.queries.companies.loading,
      placeholder: "Select company",
    },
    on: { search: (v) => (_vm.searchString = v), input: _vm.handleInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }